import React, { useState, useEffect } from "react";

import './NewContact.css';

import { SvgClose } from "components/SvgFile";

import { RegisterModalData, RegisterModalObserver, SetModalState } from "interface/InterfacePopUp";

import { Reg_NewContact } from "services/RegisterData";

export default function PopUp_NewContact(props){

    const [ modalData, setModaldata ] = useState({});
    const [ showPopUp, setShowPopUp ] = useState(false);

    const [ name, setName ]         = useState('');
    const [ email, setEmail ]       = useState('');
    const [ phone, setPhone ]       = useState('');
    const [ position, setPosition ] = useState('');

    useEffect(()=>{
        RegisterModalData('NewContact', setModaldata);
        RegisterModalObserver('NewContact', setShowPopUp);
    }, []);

    function ClosePopUp(){
        SetModalState('NewContact', false);
    }

    function SaveData(){
        Reg_NewContact(modalData.id, name, email, phone, position, ()=>{ CallbackSuccess() }, ()=>{ CallbackError() });
    }

    function CallbackSuccess(){
        ClosePopUp();
    }

    function CallbackError(){
    }

    return (
        (showPopUp ?
            <>
                <div className="PopUp">
                    <div className="all new_contact">
                        <div className="div_data type_div">
                            <div className="title">
                                Novo contato
                            </div>
                            <div className="close" onClick={ ()=>{ ClosePopUp(); } }>
                                <SvgClose color="#F00000" className="icons" />
                            </div>
                        </div>
                        <div className="div_data" style={ { paddingTop: 0 } }>
                            <div className="content">
                                <div className="show_input">
                                    <div className="div_input space_top space_contact">
                                        <input type="text" className="div_input space_contact" onChange={ (e)=>{ setName(e.target.value) } } maxLength="80" />
                                        <span className="span_name_input">Nome</span>
                                    </div>
                                    <div className="div_input space_top space_contact">
                                        <input type="text" className="div_input space_contact" onChange={ (e)=>{ setEmail(e.target.value) } } maxLength="40" />
                                        <span className="span_name_input">E-mail</span>
                                    </div>
                                </div>
                                <div className="show_input">
                                    <div className="div_input space_top">
                                        <input type="text" className="phone" onChange={ (e)=>{ setPhone(e.target.value) } } maxLength="20" />
                                        <span className="span_name_input">Telefone</span>
                                    </div>
                                    <div className="div_input space_top space_contact">
                                        <input type="text" className="div_input space_contact" onChange={ (e)=>{ setPosition(e.target.value) } } maxLength="50" />
                                        <span className="span_name_input">Cargo</span>
                                    </div>
                                </div>

                                <div className="register_data space_contact" onClick={ ()=>{ SaveData() } }>
                                    Cadastrar
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        : <React.Fragment></React.Fragment>)
    );
}
